var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 9.75)",
    stroke: "#FFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05 0a1.5 1.5 0 0 1 1.5 1.5v1.8h-2.9a1.5 1.5 0 0 0-1.496 1.388L5.15 4.8v8.4H1.5A1.5 1.5 0 0 1 0 11.7V1.5A1.5 1.5 0 0 1 1.5 0h6.55z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.15,
    y: 3.3,
    width: 9.55,
    height: 13.2,
    rx: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.111f07cfd9a839fb1228f9f979392609.svg";
export { ForwardRef as ReactComponent };